import React, { useEffect, useState } from "react"

export function ColorPicker() {
  const initialHue =
    getComputedStyle(document.documentElement).getPropertyValue(
      "--color-brand-hue"
    ) || 250

  const [hue, setHue] = useState(initialHue)

  useEffect(() => {
    document.documentElement.style.setProperty("--color-brand-hue", String(hue))
  }, [hue])

  return (
    <div className="fixed bottom-0 z-10 flex w-full flex-col bg-white">
      <span className="absolute top-8 left-6 font-semibold text-white">
        {hue}
      </span>
      <input
        type="range"
        min={0}
        max={360}
        value={hue}
        className="color-slider h-20 w-full"
        onChange={e => {
          setHue(Number(e.target.value))
        }}
      />
    </div>
  )
}
